exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#read-only-editor {\n    background-color: white;\n    padding: 0.5rem;\n    overflow: hidden;\n}\n.main-content {\n    padding-bottom: 0;\n}\n", ""]);

